/* eslint-disable no-param-reassign */
import { omit } from 'lodash';

export const connectIncludedData = (data, included) => {
  included.forEach((item) => {
    if (item.type === 'blog_category') {
      data.forEach((entry) => {
        entry.relationships.blog_categories.data.forEach((category, index) => {
          if (category.id === item.id) {
            entry.relationships.blog_categories.data[index] = {
              ...omit(item.attributes, 'cover_image')
            };
          }
        });
      });
    }
    if (item.type === 'patient_list') {
      data.forEach((entry) => {
        if (entry.relationships.patient.data?.id === item.id) {
          entry.relationships.patient.data = item.attributes;
        }
      });
    }
    if (item.type === 'treatment_list') {
      data.forEach((entry) => {
        if (entry.relationships.treatment.data?.id === item.id) {
          entry.relationships.treatment.data = item.attributes;
        }
      });
    }
  });

  return data;
};

export const connectIncludedDataSingleArticle = (data, included) => {
  data.relationships.blog_categories.data = [];
  data.relationships.treatment_faqs.data = [];
  included.forEach((item) => {
    switch (item.type) {
      case 'blog_category':
        data.relationships.blog_categories.data.push(item.attributes);
        break;
      case 'treatment_list':
        data.relationships.treatment.data = item.attributes;
        break;
      case 'treatment_faq':
        data.relationships.treatment_faqs.data.push(item);
        break;
      default:
        break;
    }
  });

  return data;
};
